import { styled } from '@mui/material'

export const IndicatorsContainer = styled("div")(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
}))
